import { Badge, Button, Heading, Text } from "@/design-system";

type FreeTrialCardProps = {
  onStart: () => void;
};

export const FreeTrialCard = ({ onStart }: FreeTrialCardProps) => (
  <section
    aria-labelledby="teste-gratis-title"
    className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8"
  >
    <div className="rounded-ds-xl bg-ds-ink-900 flex flex-col gap-6 p-6 sm:p-10 md:flex-row md:items-center md:justify-between">
      <div className="flex max-w-2xl flex-col items-start gap-3">
        <Badge tone="brand" solid>
          TESTE GRÁTIS
        </Badge>
        <Heading level={2} id="teste-gratis-title" className="text-ds-on-solid">
          Teste a Fidexa grátis com a carteira da sua loja
        </Heading>
        <Text className="text-ds-on-solid">
          Conecte seu sistema por API ou envie a planilha e veja a cobrança do
          crediário rodando no WhatsApp antes de contratar.
        </Text>
      </div>
      <Button size="lg" className="shrink-0" onClick={onStart}>
        Começar teste grátis
      </Button>
    </div>
  </section>
);
